var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"antialiased text-gray-900",attrs:{"id":"app"}},[_c('router-view'),_c('portal-target',{attrs:{"name":"modals"}}),_c('loading-progress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }